import React, { FC, useMemo, useState } from "react";
import RatesDropdown from "containers/retail/sections/energy-rates-3/RatesDropdown";
import Box from "evcharging/components/Box";
import RatesCheckbox from "containers/retail/sections/energy-rates-3/RatesCheckbox";
import useI18n from "evcharging/hooks/useI18n";

interface RatesTermsSelectProps {
  term: string;
  onTerm: (term: number[]) => void;
}

const options = [6, 12, 18, 24, 36, 60];

const RatesTermsSelect: FC<RatesTermsSelectProps> = (props) => {
  const { term: termString, onTerm } = props;

  const { t } = useI18n();

  const term = termString ? termString.split(",").map((item) => Number(item)) : [];

  const [open, setOpen] = useState<boolean>(false);
  const onToggle = () => setOpen(!open);
  const onCheck = (item) => () => {
    if (term.includes(item)) {
      onTerm(term.filter((term) => term !== item));
    } else {
      onTerm([...term, item]);
    }
    onToggle();
  };

  const placeholder = useMemo(() => {
    const clone = [...term];
    clone.sort((a, b) => a - b);
    return clone.join(",") || t('rates.all-terms');
  }, [term]);

  return (
    <RatesDropdown placeholder={placeholder} open={open} onToggle={onToggle} width={160}>
      <Box padding={"0 8px"}>
        {options.map((item) => (
          <RatesCheckbox
            key={item}
            label={t('rates.n-months', { n: item })}
            checked={term.includes(item)}
            onChange={onCheck(item)}
          />
        ))}
      </Box>
    </RatesDropdown>
  );
};

export default RatesTermsSelect;
